import { File } from './models'

export class Task {
    constructor(obj = {}) {
        this.id = obj.id || null;
        this.activityId = obj.activityId || null;
        this.activity = obj.activity;
        this.assigner = obj.assigner || null;
        this.assignerId = obj.assignerId || null;
        this.assigneesAsString = obj.assigneesAsString;
        this.assignees = obj.assignees ? new Array(...obj.assignees) : [];
        this.attachments = [];
        this.category = obj.category || null;
        this.categoryId = obj.categoryId || null;
        this.contacts = obj.contacts || [];
        this.createdOn = obj.createdOn || null;
        this.deadline = obj.deadline || null;
        this.priority = obj.priority || null;
        this.priorityId = obj.priorityId || null;
        this.relatedItemId = obj.relationTypeId || null;
        this.relatedItemType = obj.relatedItemType || null;
        this.relatedItemUrl = obj.relatedItemUrl || null;
        this.status = obj.status || null;
        this.statusId = obj.statusId || null;
        this.text = obj.text;
        this.timeToFinish = obj.timeToFinish || null;
        this.title = obj.title;
        this.type = obj.type || '';
        this.typeId = obj.typeId || 'individual';

        if (obj.attachments) {
            obj.attachments.forEach(el => this.attachments.push(new File(el)));
        }
    }
}

export class TaskHistoryItem {
    constructor(obj = {}) {
        this.activity = obj.activity || '';
        this.createdOn = new Date(obj.createdOn) || null;
        this.userId = obj.userId || '';
        this.userName = obj.userName || '';
        this.text = obj.text || '';
    }
}

export class Coordination {
    constructor(obj = {}) {
        this.id = obj.id || null;
        this.assigner = obj.assigner || null;
        this.assignerId = obj.assignerId || null;
        this.attachments = [];
        this.clerk = obj.clerk || null;
        this.clerkId = obj.clerkId || null;
        this.coordinatorsAsString = obj.coordinatorsAsString;
        this.coordinators = obj.coordinators ? [...obj.coordinators] : [];
        this.createdBy = obj.createdBy || '';
        this.createdByUserName = obj.createdByUserName || '';
        this.createdOn = obj.createdOn || null;
        this.deadline = obj.deadline || '';
        this.relatedItemId = obj.relationTypeId || null;
        this.relatedItemType = obj.relatedItemType || null;
        this.relatedItemUrl = obj.relatedItemUrl || null;
        this.request = obj.request || null;
        this.status = obj.status || null;
        this.statusId = obj.statusId || null;
        this.title = obj.title || null;
        this.type = obj.type || '';
        this.typeId = obj.typeId || 'internal';
        this.itemLink = obj.itemLink || '';

        if (obj.attachments) {
            obj.attachments.forEach(el => this.attachments.push(new File(el)));
        }
    }
}

export class Signing {
    constructor(obj = {}) {
        this.id = obj.id || null;
        this.title = obj.title || null;
        this.request = obj.request || null;
        this.creatorName = obj.creatorName;
        this.deadline = obj.deadline || '';
        this.request = obj.request || null;
        this.relatedTaskId = obj.relatedTaskId;
        this.relatedCoordinationId = obj.relatedCoordinationId;
        this.signatories = obj.signatories ? [...obj.signatories] : [];
        this.attachments = [];
        this.statusId = obj.statusId;

        if (obj.attachments) {
            obj.attachments.forEach(el => this.attachments.push(new File(el)));
        }
    }
}
